export const placement = [
  {
    name: 'SGL',
    description: '1 взрослый',
  },
  {
    name: 'DBL',
    description: '2 взрослых',
  },
  {
    name: 'TWN',
    description: 'Двухместное размещение с двумя отдельными кроватями',
  },
  {
    name: 'TRPL',
    description: 'Трёхместное размещение (3 взрослых)',
  },
  {
    name: 'QDPL',
    description: 'Четырёхместное размещение (4 взрослых)',
  },
  {
    name: 'DBL+EXB',
    description: '2 взрослых + доп. место',
  },
  {
    name: 'TWN+EXB',
    description: '2 отдельных кровати + доп. место',
  },
  {
    name: 'SGL+1CHD',
    description: '1 взрослый и 1 ребёнок',
  },
  {
    name: 'DBL+1CHD',
    description: '2 взрослых и 1 ребёнок',
  },
  {
    name: 'DBL+2CHD',
    description: '2 взрослых и 2 ребёнка',
  },
  {
    name: 'DBL+2CHD',
    description: '2 взрослых и 2 ребёнка',
  },
];

export default placement;
